<div class="row">
    <div class="col-12">
        <div *ngIf="showManualHeader" class="form-group row" [style.z-index]="3">
            <div class="col-md-6"></div>
            <label class="col-md-6 manualDateLabel">
                <ng-content select="entryDateLabel"></ng-content>
            </label>
            <input type="text" class="col-md-4 form-control" bsDatepicker [formControl]="entryDate">
            <button class="btn btn-primary col-md-2" [disabled]="!entryDate" (click)="submitPayPledge()">Pay
                Pledges
            </button>
        </div>
        <div *ngIf="showEntryDate" class="form-group row" [style.z-index]="3">
            <div class="col-md-6">
                <label>
                    <ng-content select="entryDateLabel"></ng-content>
                </label>
                <input type="text" class="w-100 form-control" bsDatepicker [formControl]="entryDate">
            </div>
        </div>
        <div *ngIf="showEndDate" class="form-group row" [style.z-index]="3">
            <div class="col-md-6">
                <label>
                    <ng-content select="entryDateLabel"></ng-content>
                </label>
                <input type="text" class="w-100 form-control" bsDatepicker [formControl]="endDate">
            </div>
        </div>
        <div *ngIf="showDateRange" class="form-group row">
            <div class="col-md-6">
                <label>Start Date:</label>
                <input type="text" class="w-100 form-control" bsDatepicker [formControl]="startDate" [style.z-index]="2">
            </div>
            <div class="col-md-6">
                <label>End Date:</label>
                <input type="text" class="w-100 form-control" bsDatepicker [formControl]="endDate" [style.z-index]="1">
            </div>
        </div>
        <div *ngIf="showDisplayPledgeStatus" class="form-group row">
            <label class="col-md-3">Displayed Pledge Status(es):</label>
            <div class="col-md-9">
                <select pledgeStatus [formControl]="displayPledgeStatus" class="form-control"></select>
            </div>
        </div>
        <div *ngIf="showShiftPledgeStatus" class="form-group row">
            <label class="col-md-3">Shift Pledge Status(es):</label>
            <div class="col-md-9">
                <select pledgeStatus [formControl]="shiftPledgeStatus" class="form-control"></select>
            </div>
        </div>
        <div *ngIf="showPledgeTypes" class="form-group row">
            <label class="col-md-3">Fund Type:</label>
            <div class="col-md-9">
                <select pledgeTypes [formControl]="pledgeTypeId" class="form-control" name="pledgeType">
                    <option [value]="[]">All Fund Types</option>
                </select>
            </div>
        </div>
        <div *ngIf="showMultiChoicePledgeTypes" class="form-group row">
            <label class="col-md-3">Fund Type:</label>
            <div class="col-md-9">
                <pledgeTypeCheckbox [showSelectAll]="true"
                                    [filterByRole]="filterPledgeTypesByRole"
                        [control]="pledgeTypeIds" [requireOne]="true"
                                    [preselectAll]="true"></pledgeTypeCheckbox>
            </div>
        </div>
        <div *ngIf="showCompany" class="form-group row">
            <label class="col-md-3">Company:</label>
            <div *ngIf="companyLock.locked; else companyPicker" class="col-md-9">
                <input *ngIf="!hasNoAssignedCompany; else noAssignedCompany" type="text" class="form-control"
                       data-testid="locked-company" [value]="companyLock.companyName" readonly>
                <ng-template #noAssignedCompany>
                    <div class="text-danger" data-testid="no-assigned-company">
                        Your account is not assigned to a company. Contact a System Admin.
                    </div>
                </ng-template>
            </div>
            <ng-template #companyPicker>
                <div class="col-md-9">
                    <input #company type="text" class="form-control" (click)="companyListModal.openModal()"
                           value="All Companies">
                    <company-box
                            (onCompanySelected)="companySelected($event); company.value = ($event?.noCompany ? 'All Companies' : $event?.company?.name) || 'All Companies'"></company-box>
                </div>
            </ng-template>
        </div>
        <ng-content select="[footer]"></ng-content>
    </div>

    <prompt-dialog
            [titleText]="'Update Pledges?'"
            [promptText]="'Are you sure you want to update the following pledges to a ' + shiftPledgeStatusDisplay?.toLowerCase() + ' status?'">
    </prompt-dialog>
</div>
